.container {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  min-width: 0;
}

.asset-name {
  color: inherit;
  font: inherit;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.edit-button {
  all: unset;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
  color: inherit;
  opacity: 0;
  transition: opacity 0.1s ease-in;

  svg {
    width: 1.3rem;
    height: 1.3rem;
  }

  .container:hover &,
  .container:focus-within & {
    opacity: 0.7;
  }

  &:hover {
    opacity: 1 !important;
  }
}

.input-sizer {
  display: inline-grid;
  align-items: center;
  max-width: 100%;
  vertical-align: bottom;

  /* The input and the mirror share the same grid cell, so the cell — and thus
   * the input — is exactly as wide as the current text. */
  &::after,
  & > input {
    grid-area: 1 / 1;
    width: auto;
    min-width: 1ch;
    font: inherit;
    margin: 0;
    padding: 0;
    white-space: pre;
  }

  &::after {
    content: attr(data-value) ' ';
    visibility: hidden;
  }
}

.name-input {
  color: inherit;
  background: transparent;
  border: none;
  border-bottom: 1px solid var(--color-secondary);
  outline: none;
}
